var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07092 1.21338C3.82852 1.21338 1.19092 3.85098 1.19092 7.09338C1.19092 10.2792 6.65708 14.9499 6.89004 15.147C6.94212 15.1913 7.00652 15.2134 7.07092 15.2134C7.13532 15.2134 7.19972 15.1913 7.2518 15.147C7.48476 14.9499 12.9509 10.2792 12.9509 7.09338C12.9509 3.85098 10.313 1.21338 7.07092 1.21338ZM7.07092 14.5618C6.11948 13.721 1.75092 9.71558 1.75092 7.09338C1.75092 4.15982 4.13736 1.77338 7.07092 1.77338C10.0045 1.77338 12.3909 4.15982 12.3909 7.09338C12.3909 9.71558 8.02208 13.721 7.07092 14.5618Z",
    fill: "#383838",
    stroke: "#383838",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.ef31abce.svg";
export { ForwardRef as ReactComponent };